import { KYMW1407Model } from '../kymw1407.model';
import { UpdateUseImageModel } from '../../kymw1400/vo/update-use-image.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用画像を更新する。
 *
 * @export
 * @class UpdateUseImageService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateUseImageService extends PlessJsonResponderSub<any> {

  private vo: UpdateUseImageModel = null;
  private model: KYMW1407Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateUseImageService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.useImageList.map((ui, i) => ({
      condition: {
        ImageId: ui.ImageId,
        ShowSeq: i + 1
      }
    }));

    return new PlessRequest({
      update: {
        UseImage: {
          parameter: {
            KomaId: this.vo.komaId
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {UpdateUseImageModel} vo
   * @memberof UpdateUseImageService
   */
  execute(model: KYMW1407Model, vo: UpdateUseImageModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14updateUseImage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof UpdateUseImageService
   */
  success(_: any) {
    this.model.updateContextMenuEnabled();

    // 親画面を更新する
    this.model.refreshKYMW1400();
  }
}
